import { create } from "zustand";

interface NavigationLeftState {
	open: boolean;
	setOpen: (open: boolean) => void;
	toggle: () => void;
}

export const useNavigationLeft = create<NavigationLeftState>((set) => ({
	open: false,
	setOpen: (open) => set({ open }),
	toggle: () => set((state) => ({ open: !state.open })),
}));
